var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "campaign-holder" }, [
    !_vm.setupVal(_vm.campaignId) &&
    !_vm.enabled(_vm.campaignId) &&
    !_vm.affiliateView
      ? _c(
          "div",
          { attrs: { "data-cy": "rtb-disabled-section" } },
          [
            _c("SectionHeader", {
              attrs: {
                "show-content": _vm.dynamicInboundCallsSettingsShowContents,
                "widget-title": _vm.$t("HEADER_DYNAMIC_INBOUND_CALLS")
              },
              on: {
                onShowContentsClick:
                  _vm.onDynamicInboundCallsSettingsShowContentsClick
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c(
                          "form",
                          {
                            staticClass: "form-horizontal",
                            attrs: {
                              role: "form",
                              name: "dynamicInboundCallsSettings"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bs-callout bs-callout-sm bs-callout-primary m-10"
                              },
                              [
                                _c("h2", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "RTB_INTRO",
                                      expression: "'RTB_INTRO'"
                                    }
                                  ]
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("Field", {
                              attrs: {
                                label: _vm.$t("LABEL_ENABLED"),
                                "hide-label": false,
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("TOOLTIP_ENABLED")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("nzToggle", {
                                          attrs: {
                                            "data-cy": "rtb-disabled-toggle"
                                          },
                                          on: { onToggle: _vm.onEnabledToggle }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3377097971
                              )
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1378070079
              )
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.setupVal(_vm.campaignId) && _vm.affiliateView
      ? _c(
          "div",
          { staticClass: "bs-callout bs-callout-sm bs-callout-primary" },
          [
            _c("h2", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "RTB_INTRO_FOR_DISABLED_PUB",
                  expression: "'RTB_INTRO_FOR_DISABLED_PUB'"
                }
              ]
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.setupVal(_vm.campaignId) || _vm.enabled(_vm.campaignId)
      ? _c(
          "div",
          { attrs: { "data-cy": "rtb-enabled-section" } },
          [
            _c("ValidationObserver", {
              ref: "formValidation",
              attrs: { slim: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function({ pristine, handleSubmit }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return handleSubmit(_vm.onSaveAll)
                              }
                            }
                          },
                          [
                            _c("DynamicInboundCallsSettings", {
                              attrs: {
                                "campaign-id": _vm.campaignId,
                                affiliate: _vm.affiliate,
                                "affiliate-view-rtb-id": _vm.affiliateView
                                  ? _vm.affiliateViewRtbId(_vm.campaignId)
                                  : "",
                                "affiliate-view": _vm.affiliateView,
                                "overrides-available": _vm.overridesAvailable,
                                "override-dynamic-inbound-calls-settings": _vm.campaignSettingsOverride(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                enabled: _vm.enabled(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                campaginIdAndAffiliateId:
                                  _vm.campaginIdAndAffiliateId,
                                "sip-only": _vm.sipOnly(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                "caller-id-required": _vm.callerIdRequired(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                icp: _vm.icp(_vm.campaignId, _vm.affiliateId),
                                "journaya-tcpa": _vm.journayaTcpa(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                "trusted-form": _vm.trustedForm(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                "trusted-form-integration": _vm.trustedFormIntegration(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                "trusted-form-settings": _vm.trustedFormSettings(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                "jornaya-settings": _vm.jornayaSettings(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                ),
                                callCaps: _vm.selectedCallCaps,
                                "payout-capacity": _vm.payoutCapacity(
                                  _vm.campaignId,
                                  _vm.affiliateId
                                )
                              },
                              on: {
                                overrideDynamicInboundCallsSettingsToggle:
                                  _vm.onCampaignSettingsOverrideToggle,
                                onEnabledToggle: _vm.onEnabledToggle,
                                onOnlySipToggle: _vm.onOnlySipToggle,
                                onCallerIdRequiredToggle:
                                  _vm.onCallerIdRequiredToggle,
                                onIcpChange: _vm.onIcpChange,
                                onJournayaTcpaChange: _vm.onJournayaTcpaChange,
                                onTrustedFormChange: _vm.onTrustedFormChange,
                                onTrustedFormIntegrationChange:
                                  _vm.onTrustedFormIntegrationChange,
                                onTrustedFormSettingsChange:
                                  _vm.onTrustedFormSettingsChange,
                                onJornayaSettingsChange:
                                  _vm.onJornayaSettingsChange,
                                onPayoutCapsChange: _vm.onPayoutCapsChange,
                                onCallCapsChange: _vm.onCallCapsChange
                              }
                            }),
                            _vm._v(" "),
                            _vm.enabled(_vm.campaignId, _vm.affiliateId)
                              ? _c(
                                  "div",
                                  [
                                    _c("BidDurationSettings", {
                                      attrs: {
                                        "affiliate-view": _vm.affiliateView,
                                        "overrides-available":
                                          _vm.overridesAvailable,
                                        "bid-expiration-in-seconds": _vm.bidExpirationInSeconds(
                                          _vm.campaignId,
                                          _vm.affiliateId
                                        ),
                                        "route-calls-for-stale-bids": _vm.routeCallsForStaleBids(
                                          _vm.campaignId,
                                          _vm.affiliateId
                                        ),
                                        "caller-id-required": _vm.callerIdRequired(
                                          _vm.campaignId,
                                          _vm.affiliateId
                                        )
                                      },
                                      on: {
                                        onBidGoodForOnInput:
                                          _vm.onBidGoodForOnInput,
                                        onBidGoodForOnChange:
                                          _vm.onBidGoodForOnChange,
                                        onRouteCallsForStaleBidsChange:
                                          _vm.onRouteCallsForStaleBidsChange
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("RateLimit", {
                                      attrs: {
                                        "affiliate-view": _vm.affiliateView,
                                        "overrides-available":
                                          _vm.overridesAvailable,
                                        "override-rate-limit-settings": _vm.rateLimitOverride(
                                          _vm.campaignId,
                                          _vm.affiliateId
                                        ),
                                        "max-requests": _vm.maxRequests(
                                          _vm.campaignId,
                                          _vm.affiliateId
                                        ),
                                        "per-seconds": _vm.perSeconds(
                                          _vm.campaignId,
                                          _vm.affiliateId
                                        ),
                                        "per-seconds-dropdown-config":
                                          _vm.perSecondsDropdownConfig
                                      },
                                      on: {
                                        overrideRateLimitSettingsToggle:
                                          _vm.onRateLimitOverrideToggle,
                                        onMaximumRequestsOnInput:
                                          _vm.onMaximumRequestsOnInput,
                                        onMaximumRequestsOnChange:
                                          _vm.onMaximumRequestsOnChange,
                                        onPerSecondsDropdownOnChange:
                                          _vm.onPerSecondsDropdownOnChange
                                      }
                                    }),
                                    _vm._v(" "),
                                    !_vm.affiliateView
                                      ? _c("DefaultBidSettings", {
                                          attrs: {
                                            "pass-through-bid-feature-flag":
                                              _vm.passThroughBidFeatureFlag,
                                            "overrides-available":
                                              _vm.overridesAvailable,
                                            "current-pass-through-bid": _vm.passThroughBid(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "override-default-bid-settings": _vm.bidSettingsOverride(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "base-bid-amount": _vm.baseBidAmount(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "max-bid-amount": _vm.maxBidAmount(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "min-bid-amount": _vm.minBidAmount(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "conversion-type": _vm.conversionType(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "conversion-type-dropdown-config":
                                              _vm.conversionTypeDropdownConfig,
                                            "start-timer-event": _vm.startTimerEvent(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "call-length-in-seconds": _vm.callLengthInSeconds(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "payout-hours-toggleval":
                                              _vm.payoutHoursToggleval,
                                            "seconds-from-last-call": _vm.secondsFromLastCall(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "limit-payout-toggleval":
                                              _vm.limitPayoutToggleval
                                          },
                                          on: {
                                            overrideDefaultBidSettingsToggle:
                                              _vm.onBidSettingsOverrideToggle,
                                            onBaseBidAmountOnInput:
                                              _vm.onBaseBidAmountOnInput,
                                            onBaseBidAmountOnChange:
                                              _vm.onBaseBidAmountOnChange,
                                            onmaxBidAmountOnInput:
                                              _vm.onmaxBidAmountOnInput,
                                            onmaxBidAmountOnChange:
                                              _vm.onmaxBidAmountOnChange,
                                            onminBidAmountOnInput:
                                              _vm.onminBidAmountOnInput,
                                            onminBidAmountOnChange:
                                              _vm.onminBidAmountOnChange,
                                            onPayoutOnDropdownOnChange:
                                              _vm.onPayoutOnDropdownOnChange,
                                            onStartTimerEventChange:
                                              _vm.onStartTimerEventChange,
                                            onCallLengthInSecondsOnInput:
                                              _vm.onCallLengthInSecondsOnInput,
                                            onCallLengthInSecondsOnChange:
                                              _vm.onCallLengthInSecondsOnChange,
                                            onPayoutHoursToggle:
                                              _vm.onPayoutHoursToggle,
                                            onSecondsFromLastCallChange:
                                              _vm.onSecondsFromLastCallChange,
                                            onLimitPayoutToggle:
                                              _vm.onLimitPayoutToggle
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.affiliateView &&
                                    _vm.passThroughBidFeatureFlag
                                      ? _c("DefaultPassThroughBid", {
                                          attrs: {
                                            "overrides-available":
                                              _vm.overridesAvailable,
                                            "current-pass-through-bid": _vm.passThroughBid(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "override-default-pass-through-bid": _vm.passThroughBidOverride(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "current-pass-through-bid-override": _vm.passThroughBidOverrideValues(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "current-min-duration-adjustments": _vm.minDurationAdjustments(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "current-min-duration-adjustments-override": _vm.minDurationAdjustmentsOverride(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            )
                                          },
                                          on: {
                                            updatePassThroughBid:
                                              _vm.onUpdatePassThroughBid,
                                            enablePassThroughBidToggle:
                                              _vm.onEnablePassThroughBidToggle,
                                            overrideDefaultPassThroughBidToggle:
                                              _vm.onPassThroughBidOverrideToggle,
                                            updateMinDuration:
                                              _vm.onMinDurationAdjustmentChange
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.affiliateView && !_vm.affiliateId
                                      ? _c("CustomScoringSettings", {
                                          attrs: {
                                            "has-custom-scoring-v1": _vm.hasCustomScoringV1(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "current-custom-scoring": _vm.customScoring(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "custom-scoring-modified": _vm.customScoringModified(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "save-triggered":
                                              _vm.customScoringUpdatedSuccess
                                          },
                                          on: {
                                            updateCustomScoringModified:
                                              _vm.onUpdateCustomScoringModified,
                                            updateCustomScoringSettings:
                                              _vm.onUpdateCustomScoringSettings,
                                            resetCustomScoringUpdatedSuccess:
                                              _vm.onResetCustomScoringUpdatedSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.affiliateView
                                      ? _c("BidAdjustments", {
                                          attrs: {
                                            "overrides-available":
                                              _vm.overridesAvailable,
                                            "override-default-bid-settings":
                                              _vm.overrideDefaultBidSettings,
                                            "override-bid-adjustments": _vm.bidAdjustmentsOverride(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            rows: _vm.rows(
                                              _vm.campaignId,
                                              _vm.affiliateId
                                            ),
                                            "bulk-modifiers": _vm.bulkModifiers,
                                            "current-row": _vm.currentRow,
                                            "last-row-id": _vm.lastRowId,
                                            "edit-row": _vm.editRow,
                                            headers: _vm.headers,
                                            "show-add-adjustment-button":
                                              _vm.showAddAdjustmentButton,
                                            "adjustments-changed":
                                              _vm.adjustmentsChanged,
                                            "adjustment-panel-properties": {
                                              availableTags: _vm.availableTags,
                                              recentlyUsedTags:
                                                _vm.recentlyUsedTags,
                                              valuesForFilter:
                                                _vm.valuesForFilter,
                                              comparisonTypes:
                                                _vm.comparisonTypes,
                                              operationTypes: _vm.operationTypes
                                            },
                                            "hide-save-and-cancel":
                                              _vm.hideSaveAndCancel
                                          },
                                          on: {
                                            overrideBidAdjustmentsToggle:
                                              _vm.onBidAdjustmentsOverrideToggle,
                                            onAddAdjustment:
                                              _vm.onAddAdjustment,
                                            onEditAdjustment:
                                              _vm.onEditAdjustment,
                                            onAddAdjustmentButtonClick:
                                              _vm.onAddAdjustmentButtonClick,
                                            onResetAdjustments:
                                              _vm.onResetAdjustments,
                                            onSaveAdjustments: _vm.onSaveAll,
                                            onCancelAdjustments:
                                              _vm.onCancelAdjustments,
                                            onOrderChange: _vm.onOrderChange,
                                            drag: _vm.onDrag,
                                            onSetCurrentRow:
                                              _vm.onSetCurrentRow,
                                            onToggleEditRow:
                                              _vm.onToggleEditRow,
                                            onShowRowAdjustment:
                                              _vm.onShowRowAdjustment,
                                            onRemoveRow: _vm.onRemoveRow
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.affiliateView && !_vm.hideSaveAndCancel
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "save-btns-dynamic-inbound-calls col-sm-offset-2 col-md-offset-3 m-b-25"
                                  },
                                  [
                                    _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "BUTTON_SAVE",
                                          expression: "'BUTTON_SAVE'"
                                        }
                                      ],
                                      staticClass:
                                        "btn btn-primary bid-adjustment-btn m-t-20 m-l-20",
                                      attrs: {
                                        name: "rtb-form-save-button",
                                        "data-cy": "rtb-form-save-button",
                                        disabled:
                                          (_vm.showAddAdjustmentButton ||
                                            _vm.affiliateView ||
                                            (pristine &&
                                              !_vm.adjustmentsChanged)) &&
                                          _vm.setupVal(_vm.campaignId),
                                        type: "submit"
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1983456079
              )
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }